export default __webpack_public_path__ + "static/media/red-alert.7884bbad.svg";